<template>
  <div class="printing">
    <div class="head1">
      <h3>{{ configure.title }}（打印员）<em>登录页</em></h3>
    </div>
    <div class="main1">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>登录</span>
        </div>
        <el-form ref="form" :model="form" label-width="0px">
          <el-form-item>
            <el-input prefix-icon="el-icon-user-solid" v-model="username"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              prefix-icon="el-icon-s-tools"
              v-model="password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="login">登录</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="footer1"><span>长水教育集团</span></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      username: "",
      password: "",
      user: "",
      isForm: false,
    };
  },
  computed: {
    ...mapState(["configure"]),
  },
  mounted() {
    // this.loginDockkey();
  },
  methods: {
    login() {
      this.$ajax
        .post(`/server/print/user/login`, {
          loginName: this.username,
          password: this.password,
        })
        .then((res) => {
          sessionStorage.clear();
          window.sessionStorage.setItem("user", JSON.stringify(res));
          this.$router.push({ name: "print" });
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/loginPrinting.vue